import {
  parseAgreementIssuance,
  parseAgreementRecord,
  parseAgreementStatus,
} from '../../../../helpers/driverAgreement'
import { AgreementApi } from '../../../../types/driverAgreements'
import { driverClient } from '../../driverClient'

export const driverAgreements = {
  forUser(uid: string): AgreementApi {
    const request = (path: string, body: unknown, signal: AbortSignal) =>
      driverClient.request(uid, path, body, signal)
    return {
      accept: async (id, hash, signal) =>
        parseAgreementRecord(
          await request(
            `${id}/accept`,
            {
              accepted: true,
              source_channel: 'portal',
              template_sha256: hash,
            },
            signal
          )
        ),
      issue: async (signal) =>
        parseAgreementIssuance(
          await request('issuances', { source_channel: 'portal' }, signal)
        ),
      read: async (id, signal) =>
        parseAgreementRecord(await request(String(id), undefined, signal)),
    }
  },
  async status(uid: string, signal: AbortSignal) {
    return parseAgreementStatus(
      await driverClient.request(uid, 'status', undefined, signal)
    )
  },
}
